var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:#B4A06E;}\r\n"),React.createElement("path",{"className":"st0","d":"M0,0v30h15.17V17.91h-3.38v-4.55h3.38v-2.73c0,0-0.13-6.63,6.24-6.63c2.34,0,3.38,0,3.38,0v4.55h-2.34\r\n\tc0,0-2.47,0.39-2.47,2.08v2.73h4.81v4.55h-4.81V30H30V0H0z","key":1})]);
}

Facebook.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 30 30","style":{"enableBackground":"new 0 0 30 30"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
